module.exports = __webpack_public_path__ + "assets/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4iaVIGxA-bc9146.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4iaVIGxA.woff2
// module id = 855
// module chunks = 2